import React from "react";

const UserOut = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
          className="u_fill"
          d="M18.97 21.724v11.532H4c0-1.818.418-3.611 1.222-5.243a11.921 11.921 0 013.42-4.173 12.044 12.044 0 0110.33-2.116zm-2.993-1.864c-4.963 0-8.983-3.996-8.983-8.93 0-4.934 4.02-8.93 8.983-8.93 4.962 0 8.982 3.996 8.982 8.93 0 4.934-4.02 8.93-8.982 8.93zm8.982 5.954v-5.21l7.485 6.698L24.96 34v-5.21h-4.491v-2.976h4.491z"
          fill={fill}
      />
    </svg>
);
export default UserOut;
